import twitterIcon from 'public/static/images/social_media/twitter.svg';
import css from 'styled-jsx/css';
import ShareItem from './ShareItem';

interface TwitterShareItemProps {
  shareText: string;
  url: string;
  onClick: () => void;
}

const twitterIconCss = css.resolve`
  .twitter-icon {
    width: 30px;
    height: 30px;
    margin: 0;
  }
`;

const TwitterShareItem = ({ shareText, url, onClick }: TwitterShareItemProps): JSX.Element => {
  return (
    <ShareItem
      actionText={'Twitter'}
      iconImage={twitterIcon}
      linkUrl={`https://twitter.com/intent/tweet?url=${url}&text=${shareText}`}
      onClick={onClick}
      iconClass={`twitter-icon ${twitterIconCss.className}`}
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      iconCss={twitterIconCss}
    />
  );
};

export default TwitterShareItem;
